import React from "react";
import PropTypes from "prop-types";
// Material imports
import withStyles from "@mui/styles/withStyles";
import { useTheme } from "@mui/styles";
// Limitless imports
import Typography from "@limitless/modern/data-display/typography/Typography";
import TimePosted from "../time-posted/TimePosted";
import { useExpertMessageContext } from "../../../../../expert";
const ExpertTimePosted = ({
  classes,
  time,
  dialogue
}) => {
  const {
    dialogueId
  } = dialogue;
  const {
    dialogueError
  } = useExpertMessageContext();
  const theme = useTheme();
  return /*#__PURE__*/React.createElement("div", {
    className: classes.responseTime
  }, dialogueError && dialogueError === dialogueId ? /*#__PURE__*/React.createElement(Typography, {
    variant: "caption",
    color: theme.palette.error.dark
  }, "Failed to send. Click to try again.") : /*#__PURE__*/React.createElement(TimePosted, {
    time: time
  }));
};
const styles = {
  responseTime: {
    display: "flex",
    justifyContent: "flex-end",
    paddingTop: 8
  }
};
export default withStyles(styles)(ExpertTimePosted);
ExpertTimePosted.propTypes = {
  classes: PropTypes.object.isRequired,
  dialogue: PropTypes.object.isRequired,
  time: PropTypes.oneOfType([PropTypes.number, PropTypes.string])
};